module.exports = __webpack_public_path__ + "static/img/posterProduct4.468fab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterProduct4.png
// module id = qfeb
// module chunks = 2